import React, { Fragment, useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { LanguageContext } from '../../contexts/LanguageContext';
import { UserContext } from '../../contexts/UserContext';
import { withCookies } from 'react-cookie';
import PropTypes from 'prop-types';
import Traductor from '../Traductor';
import Globals from '../../Globals';
import Trolley from '../batches/Trolley/NavbarTrolley';
import usePermissions from 'hooks/usePermissions';

import '../css/profile.css';
import '../css/pageHead.css';

function PageHead({
    history,
    cookies,
    isOpenMegaMenuParent,
    setNewStatusMegaMenu,
}) {
    const t = new Traductor();

    const { user, setLogged } = useContext(UserContext);
    const [isOpenMegaMenu, setIsOpenMegaMenu] = useState(isOpenMegaMenuParent);
    const { checkPermission } = usePermissions();
    useEffect(() => {
        window.bronson.ComponentRegister.initAll();
    });

    useEffect(() => {
        setIsOpenMegaMenu(isOpenMegaMenuParent);
    }, [isOpenMegaMenuParent]);

    const onClickGoToProfile = type => {
        history.push(Globals.APPLICATION_PATH.PROFILE + '/' + type);
    };
    const logOff = () => {
        document
            .getElementById('UserMenuDropdown')
            .setAttribute('aria-hidden', 'true');
        cookies.remove(Globals.COOKIES.JWT, { path: process.env.PUBLIC_URL });
        cookies.remove(Globals.COOKIES.USER, { path: process.env.PUBLIC_URL });
        setLogged(false);
        history.push({
            pathname: `${Globals.APPLICATION_PATH.LOGIN}`,
            state: {
                pendingRefresh: true,
            },
        });
    };

    const getNameUser = (character = false) => {
        let name = null;
        let surname = null;
        let result = '';

        if (character) {
            name = user.data.Name !== undefined ? user.data.Name.charAt(0) : '';
            surname =
                user.data.Surname !== undefined
                    ? user.data.Surname.charAt(0)
                    : '';
            result = name + surname;
        } else {
            name = user.data.Name !== undefined ? user.data.Name : '';
            surname = user.data.Surname !== undefined ? user.data.Surname : '';
            result = name + ' ' + surname;
        }
        return result;
    };

    const renderMenu = logged => {
        // if (logged) {
        return (
            <Fragment>
                {checkPermission('CNST_GESTION_COMERCIAL_CONCESIONARIO') ? (
                    <Trolley />
                ) : (
                    <div></div>
                )}
                <li className="c-page-head-nav__item c-header-profile-dropdown js-dropdown">
                    <a
                        className="c-page-head-nav__link c-header-profile-dropdown__link js-dropdown__button"
                        href="#0"
                    >
                        <div className="c-header-profile-dropdown__link-container">
                            <span className="c-page-head-nav__link-text">
                                {getNameUser()}
                            </span>
                            <i className="c-page-head-nav__link-icon  c-icon  c-icon--small  c-icon--[control-user]"></i>
                        </div>
                    </a>
                    <div
                        id="UserMenuDropdown"
                        className="c-page-head-nav__dropdown  js-dropdown__panel"
                    >
                        <ul className="c-page-head-nav__dropdown-content  c-page-head-nav__dropdown-content--list">
                            <li className="c-page-head-nav__dropdown-list-item">
                                <a
                                    className="c-page-head-nav__dropdown-list-link"
                                    onClick={() =>
                                        onClickGoToProfile('account')
                                    }
                                >
                                    {t.getTraduction('EditProfile')}
                                </a>
                            </li>
                            <li className="c-page-head-nav__dropdown-list-item">
                                <a
                                    className="c-page-head-nav__dropdown-list-link"
                                    onClick={() =>
                                        onClickGoToProfile('password')
                                    }
                                >
                                    {t.getTraduction('CambiarContraseña')}
                                </a>
                            </li>
                            <li className="c-page-head-nav__dropdown-list-item">
                                <a
                                    className="c-page-head-nav__dropdown-list-link"
                                    onClick={logOff}
                                >
                                    <span className="o-media  o-media--small  o-media--middle">
                                        <span className="o-media__img">
                                            <i className="c-mega-menu__icon  c-icon  c-icon--xsmall  c-icon--[control-logout]"></i>
                                        </span>
                                        <span className="o-media__body">
                                            {t.getTraduction('CerrarSession')}
                                        </span>
                                    </span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </li>
                <li className="c-page-head-nav__item">
                    <a
                        className={
                            'c-page-head-nav__link  js-mega-menu-trigger ' +
                            (isOpenMegaMenu ? 'is-open' : '')
                        }
                        onClick={() => setNewStatusMegaMenu(!isOpenMegaMenu)}
                    >
                        <i className="c-page-head-nav__link-icon  c-burger">
                            <span></span>
                        </i>
                    </a>
                </li>
            </Fragment>
        );
    };

    return (
        <Fragment>
            <ul className="c-page-head-nav">{renderMenu(user.logged)}</ul>
        </Fragment>
    );
}

PageHead.propTypes = {
    availableLanguages: PropTypes.array.isRequired,
    options: PropTypes.shape({
        search: PropTypes.bool,
    }),
};

export default withCookies(withRouter(PageHead));
